import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, ProjectsConstructorForm, useAppFindFormik } from '@/components';
import { AddEpicGroupDto, ProjectDto } from '@/core';
import { useTypeOptions, useEpicsOptionsByEpicType, useSchemaEpicGroup, FormValueType } from './hooks';
import classes from './EpicGroupForm.module.scss';

type PropsType = {
  initialValue: FormValueType;
  formUid: string;
  handleCancel?: () => void;
  handleSubmit: (epicGroupData: AddEpicGroupDto) => void;
  isCancelButton?: boolean;
  projectData: ProjectDto;
  isTooltip?: boolean;
  epicType?: string;
  editedGroupId?: string;
};

export const EpicGroupForm = ({
  initialValue,
  formUid,
  handleCancel,
  handleSubmit,
  isCancelButton,
  projectData,
  isTooltip = false,
  epicType,
  editedGroupId = '',
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const form = useAppFindFormik(formUid);
  const [selectedEpicType, setSelectedEpicType] = useState(epicType);
  const epicsOptions = useEpicsOptionsByEpicType(projectData, selectedEpicType!, editedGroupId);
  const typeOptions = useTypeOptions();
  const schemaEpicGroup = useSchemaEpicGroup(projectData, initialValue, selectedEpicType);

  const handleChangeType = (newType: string) => {
    setSelectedEpicType(newType);
    form.current?.setFieldValue('epics', []);
  };

  return (
    <ProjectsConstructorForm<FormValueType>
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      schema={schemaEpicGroup}
      initialValues={initialValue}
      formUid={formUid}
      isCancelButton={isCancelButton}
    >
      <div className={classes.typeSelect}>
        <Form.Select
          label={false}
          options={typeOptions}
          name="type"
          allowClear={false}
          onChange={handleChangeType}
        />
      </div>
      <div className={classes.epicGroupNameInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addEpicGroups.placeholder.name')}
        />
      </div>
      <div className={classes.epicSelect}>
        <Form.Select
          mode="multiple"
          label={false}
          options={epicsOptions}
          name="epics"
          placeholder={t('addEpicGroups.placeholder.epic')}
          required
          allowClear={false}
        />
      </div>
    </ProjectsConstructorForm>
  );
};
